import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import '../Analitos.scss';
import DataGrid, { Column, Button as Butt, Editing, Popup as Pop, Lookup, RequiredRule } from 'devextreme-react/data-grid';
import { useApiConfiguration } from '../../../api/api.configuration';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { TypeRules } from '../../../types/types.analitos';

export const ValidationRules = ({ IdAnalito }: { IdAnalito: number }) => {
  const { getValidationRules, newValidationRules, setValidationRules, deleteValidationRules } = useApiConfiguration();
  const dataRef = useRef<DataGrid>(null);

  const TypesRules = Object.keys(TypeRules)
    .map((key) => {
      if (!isNaN(Number(key))) {
        return null;
      }

      const value = TypeRules[key as keyof typeof TypeRules];
      return {
        id: value,
        text: key,
      };
    })
    .filter(Boolean);

  const customData = useMemo(() => {
    return new CustomStore({
      key: 'Rga_Id',
      load() {
        return getValidationRules(IdAnalito)
          .then((res) => ({
            data: res,
            totalCount: res.totalCount,
            summary: res.summary,
            groupCount: res.groupCount,
          }))
          .catch(() => {
            throw new Error('Error de carga de datos');
          });
      },
      insert: async (values) => {
        const newValues = {
          ...values,
          Rga_An_Id: IdAnalito,
        };
        return newValidationRules({ Rules: newValues })
          .then((res) => {
            if (res === 105) {
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error insertando la regla de validación');
          });
      },
      update: (key, values) => {
        return new Promise((resolve, reject) => {
          dataRef.current?.instance
            .byKey(key)
            .then((originalRecord) => {
              // Mezclar el registro original con los valores modificados
              const fullRecord = { ...originalRecord, ...values };

              setValidationRules({ Rules: fullRecord, IdRegla: key })
                .then((res) => {
                  if (res === 107) {
                    dataRef.current?.instance.refresh();
                  }
                  resolve(res);
                })
                .catch((error) => {
                  reject(new Error('Error actualizando la regla de validación'));
                });
            })
            .catch(reject);
        });
      },
      remove: (key) => {
        return deleteValidationRules({ IdRegla: key, IdAnalito: IdAnalito }).then((res) => {
          if (res === 107) {
            dataRef.current?.instance.refresh();
          }
        });
      },
    });
  }, [IdAnalito]);

  const customDataSrc = new DataSource({
    store: customData,
    reshapeOnPush: true,
  });

  const onEditorPreparing = (e) => {
    if ((e.dataField === 'Rga_Requerido' || e.dataField === 'Rga_Estado') && e.parentType === 'dataRow') {
      e.editorName = 'dxCheckBox';
    }
  };

  return (
    <div>
      <DataGrid id='1' dataSource={customDataSrc} ref={dataRef} onEditorPreparing={onEditorPreparing}>
        <Editing mode='form' allowUpdating={true} allowAdding={true} allowDeleting={true} selectTextOnEditStart={true} />
        <Column allowGrouping={false} caption='TIPO' visible={true} allowEditing={true} dataField='Rga_Tipo' alignment='center'>
          <Lookup dataSource={TypesRules} valueExpr='id' displayExpr='text' />
          <RequiredRule />
        </Column>
        <Column allowGrouping={false} caption='REGLA' visible={true} allowEditing={true} dataField='Rga_Nombre' alignment='center'>
          <RequiredRule />
        </Column>
        <Column allowGrouping={false} caption='FÓRMULA' visible={true} allowEditing={true} dataField='Rga_Formula' alignment='center'>
          <RequiredRule />
        </Column>
        <Column allowGrouping={false} caption='ORDEN' visible={true} allowEditing={true} dataField='Rga_Orden' alignment='center'>
          <RequiredRule />
        </Column>
        <Column allowGrouping={false} caption='ESTADO' visible={true} allowEditing={true} dataField='Rga_Estado' alignment='center'>
          <RequiredRule />
        </Column>
        <Column allowGrouping={false} caption='REQUERIDO' visible={true} allowEditing={true} dataField='Rga_Requerido' alignment='center'>
          <RequiredRule />
        </Column>
        <Column type='buttons' caption={'ACCIÓN'} width={200}>
          <Butt name='edit' />
          <Butt name='delete' />
        </Column>
      </DataGrid>
    </div>
  );
};
